export enum EduTradingCurrencyStrengthType {

    M5 = "M5",
    M15 = "M15",
    H1 = "H1"
}
